module.exports = __webpack_public_path__ + "static/img/default-no_prev.78b653d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-no_prev.png
// module id = UlPp
// module chunks = 1